import mixpanel from "mixpanel-browser";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { useTheme } from "styled-components";
import { routeList } from "../../App";
import { lang } from "../../assets/languages/en.language";
import PictureInput from "../../components/form/Picture.input";
import { usePwaViewportWidth } from "../../hooks/useScreenWidth";
import api from "../../services/api";
import { getVpFontSize } from "../../services/utils";
import { useUserStore } from "../../store/useUserStore";
import { PurpleButton } from "../../styles/Button.style";
import { MainContainer, RootContainer } from "../../styles/Container.style";
import { BigTitle, Paragraph } from "../../styles/Text";
import { Gap } from "../../styles/Utils";

export default function PicturePage() {
  const {
    profile: { imageUrls },
    setImageUrls,
  } = useUserStore();
  const [selectedPictures, setSelectedPictures] = useState<(File | string | null)[]>(imageUrls);
  const [sumbmitting, setSumbmitting] = useState<boolean>(false);

  const theme = useTheme();
  const navigate = useNavigate();
  const viewportWidth = usePwaViewportWidth();

  const handleSubmission = async () => {
    setSumbmitting(true);
    const formData = new FormData();
    const files = selectedPictures.filter((e) => e != null && typeof e != "string");
    const imageUrls = selectedPictures.map((e) => (typeof e == "string" ? e : null));
    files.forEach((image) => {
      formData.append("files", image);
    });
    formData.append("persistedUrls", JSON.stringify(imageUrls));

    try {
      const response = await api.addImages(formData);
      if (response.data.imageUrls) {
        mixpanel.track("Update Pictures");
        setImageUrls(response.data.imageUrls);
        navigate(routeList.profile);
      }
    } catch (err) {
      console.log("Error adding images", err);
      alert("Error adding images");
    }
    setSumbmitting(false);
  };

  const formValid = selectedPictures.filter((e) => e != null).length > 0;

  return (
    <RootContainer>
      <BigTitle $fontSize={getVpFontSize(viewportWidth, 15)}>{lang.picturesPage.title}</BigTitle>
      <Gap $height={1} />
      <MainContainer>
        <Paragraph>{lang.picturesPage.message}</Paragraph>
        <Gap $height={1} />
        <PictureInput selectedPictures={selectedPictures} setSelectedPictures={setSelectedPictures} />
      </MainContainer>
      <Gap $height={1.5} />
      <PurpleButton type="submit" disabled={!formValid} onClick={handleSubmission}>
        {sumbmitting ? <BeatLoader color={theme.color.tertiaryLight} /> : <span>{lang.buttons.continue}</span>}
      </PurpleButton>
    </RootContainer>
  );
}
